var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import Cropper from 'react-easy-crop';
import { Dialog, DialogContent, DialogHeader, DialogTitle, } from 'root/src/client/v2/common/components/ui/dialog';
import { Slider } from 'root/src/client/v2/common/components/ui/slider';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { useAsyncAction } from 'root/src/client/v2/common/hooks/useAsyncAction';
import { getReadableError } from 'root/src/client/v2/common/helpers/getReadableError';
import { cropImageToFile } from 'root/src/client/v2/image/helpers/cropImageToFile';
// Redesign image-crop modal. Reuses the legacy crop pipeline (`react-easy-crop` for the UI +
// `cropImageToFile` for the canvas crop) inside the redesign Dialog, so it matches the look while
// keeping the proven cropping logic. `onCropped` receives the cropped File (the caller uploads it).
export const ImageCropDialog = ({ open, src, aspect = 1, onOpenChange, onCropped }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [areaPixels, setAreaPixels] = useState(null);
    const { loading, success, error, run } = useAsyncAction();
    const onApply = () => {
        if (!areaPixels) {
            return;
        }
        void run(() => __awaiter(void 0, void 0, void 0, function* () {
            const { file } = yield cropImageToFile({
                coordinates: { width: areaPixels.width, height: areaPixels.height, xPixels: areaPixels.x, yPixels: areaPixels.y },
                source: src,
            });
            yield onCropped(file);
        }), {
            successHold: 0,
            onSuccess: () => onOpenChange(false),
            toast: {
                loading: 'Saving image...',
                success: 'Image saved',
                error: caught => getReadableError(caught, 'Could not crop image'),
            },
        });
    };
    return (<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-md">
				<DialogHeader>
					<DialogTitle className="font-display">Crop image</DialogTitle>
				</DialogHeader>
				<div className="relative h-72 w-full overflow-hidden rounded-xl bg-black/40">
					{src && (<Cropper image={src} crop={crop} zoom={zoom} aspect={aspect} onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={(_, pixels) => setAreaPixels(pixels)}/>)}
				</div>
				<div className="flex items-center gap-3">
					<span className="text-[11px] font-medium text-muted-foreground">Zoom</span>
					<Slider value={[zoom]} min={1} max={3} step={0.01} onValueChange={values => { var _a; return setZoom((_a = values[0]) !== null && _a !== void 0 ? _a : 1); }} aria-label="Zoom"/>
				</div>
				<div className="flex justify-end gap-2">
					<Button type="button" variant="ghost" size="sm" onClick={() => onOpenChange(false)}>Cancel</Button>
					<Button type="button" variant="brand" size="sm" disabled={!areaPixels} loading={loading} success={success} error={error} onClick={onApply}>Apply</Button>
				</div>
			</DialogContent>
		</Dialog>);
};
